export const filterCustomFields = (fields) => fields.filter((field) => field.isCustom);
export const filterDefaultFields = (fields) => fields.filter((field) => !field.isCustom);
